/**
 * @generated SignedSource<<233f2153d4abb25eb921e59e3739a648>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleFurtherReadingWidgetArticle$data = {
  readonly entityId: string;
  readonly moreOnThisArticles: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"articleWidgetContent">;
  } | null | undefined> | null | undefined;
  readonly sponsorType: string | null | undefined;
  readonly " $fragmentType": "articleFurtherReadingWidgetArticle";
};
export type articleFurtherReadingWidgetArticle$key = {
  readonly " $data"?: articleFurtherReadingWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleFurtherReadingWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleFurtherReadingWidgetArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sponsorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "moreOnThisArticles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "articleWidgetContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "1b1fedd2280b6bb82487ec6be59ed1e4";

export default node;
